module.exports = __webpack_public_path__ + "static/media/lightning-icon.b594b833.svg";